import { KeyValueTranslated } from '../../models/translation';

export const INCOME_SOURCE: KeyValueTranslated = {
  'Employment income': (t) => t('Employment income'),
  'Business income': (t) => t('Business income'),
  'Rental income': (t) => t('Rental income'),
  'Investments income (e.g. dividends / interest)': (t) => t('Investments income (e.g. dividends / interest)'),
  'Family income / allowance': (t) => t('Family income / allowance')
};

export const WEALTH_SOURCE: KeyValueTranslated = {
  Savings: (t) => t('Savings'),
  'Family allowance': (t) => t('Family allowance'),
  Investments: (t) => t('Investments'),
  Salary: (t) => t('Salary'),
  Business: (t) => t('Business'),
  Inheritance: (t) => t('Inheritance')
};
